/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import solanaQuestions from 'images/coin-pages/questions/solana.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const solPage: ICoinPageData = {
  title: 'coin_907',
  description: 'coin_908',
  metaDescription: 'coin_sol_meta_desc',
  metaTitle: 'coin_sol_meta_title',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Solana' }) }} />
  ),
  questionsBlock: {
    image: solanaQuestions,
    questions: [
      {
        title: 'coin_909',
        answer: 'coin_910',
      },
      {
        title: 'coin_911',
        answer: 'coin_912',
      },
      {
        title: 'coin_913',
        answer: 'coin_914',
      },
      {
        title: 'coin_915',
        answer: 'coin_916',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Solana (SOL)'),
    text: ['coin_920', 'coin_921'],
    paragraphs: [
      {
        title: 'coin_917',
        text: ['coin_922', 'coin_923', 'coin_924', 'coin_925'],
      },
      {
        title: 'coin_918',
        text: ['coin_926', 'coin_927', 'coin_928', 'coin_929', 'coin_930'],
      },
    ],
    ...commonLearnMoreData('Solana (SOL)'),
  },
  videoId: 'CUF_1BFMTX8',
  videoTitle: 'coin_919',
}
